<template>
  <v-container
    fluid
    class="background-color-seashell px-0 z-index-2"
    :class="position"
    v-if="websiteFormat != 'store_info_rewards'"
  >
    <v-row no-gutters v-if="websiteFormat === 'all_items'">
      <NavTile v-for="(chip, index) in navTabs" :key="index" :chip="chip" />
    </v-row>
    <NavigationSwiper
      :menuItems="websiteFormat === 'all_items' ? menuItems : templateItems"
      v-else
    />
  </v-container>
</template>

<script>
import NavTile from "@/components/Navigation/NavTile.vue";
import { mapGetters, mapState } from "vuex";
import NavigationSwiper from "@/components/Navigation/Xs/Swiper.vue";

export default {
  name: "XsNavigation",
  components: { NavigationSwiper, NavTile },
  computed: {
    ...mapGetters("menu", { menuItems: "bySection" }),
    ...mapGetters("template", { templateItems: "byCategory" }),
    ...mapState({
      websiteFormat: (state) =>
        state.store.info.store_info.customization?.website.style
          .website_format ?? "all_items",
    }),
    position() {
      return this.fix ? "position-fixed" : "";
    },
  },
  props: { fix: Boolean, navTabs: Array },
};
</script>
<style scoped>
.position-fixed {
  position: fixed;
  /*top: 134.67px;*/
  top: 125px;
}

.z-index-2 {
  z-index: 2;
}
</style>
